import React from 'react'

import PropTypes from 'prop-types'

import './ArrowLinkListItem.css'

const ArrowLinkListItem = ({ item, onClick, className }) => {
    const itemSlug = item.slug || item.id
    const itemLink = item.link
    const idName = itemLink || itemSlug

    return (
        <div
            className={`arrow-link-list-item arrow-link-list-item--${className}`}
            id={idName}
            name={item.name}
            onClick={onClick}
        >
            <span className="arrow-link-list-item__title">{item.name}</span>
            <span className="arrow-link-list-item__arrow" />
        </div>
    )
}

ArrowLinkListItem.propTypes = {
    item: PropTypes.shape({
        name: PropTypes.string.isRequired,
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    }).isRequired,
    onClick: PropTypes.func,
    className: PropTypes.string
}

export { ArrowLinkListItem }
